<!-- AnnotationCanvas — SVG overlay clone of Magic Patterns media/CanvasOverlay.tsx -->
<svg #svg class="acv" [ngClass]="cursorClass" [attr.viewBox]="'0 0 ' + vw + ' ' + vh"
     preserveAspectRatio="none"
     (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"
     (mouseup)="onMouseUp()" (mouseleave)="onMouseUp()">
  <defs>
    <marker id="acv-arrow" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
      <svg:path d="M0,0 L8,3 L0,6 Z" fill="context-stroke"></svg:path>
    </marker>
  </defs>

  <svg:g *ngIf="showAnnotations">
    <ng-container *ngFor="let a of annotations; trackBy: trackById">
      <ng-container *ngTemplateOutlet="annTpl; context: { $implicit: a }"></ng-container>
    </ng-container>
    <ng-container *ngIf="draft">
      <ng-container *ngTemplateOutlet="annTpl; context: { $implicit: draft }"></ng-container>
    </ng-container>

    <!-- Selection box + handles -->
    <svg:g *ngIf="selected" class="acv__sel">
      <svg:rect [attr.x]="bounds(selected).x - 4" [attr.y]="bounds(selected).y - 4"
                [attr.width]="bounds(selected).w + 8" [attr.height]="bounds(selected).h + 8"
                fill="none" stroke="#3B82F6" stroke-width="1" stroke-dasharray="5,5"></svg:rect>
      <svg:rect *ngFor="let h of [
                  { x: bounds(selected).x, y: bounds(selected).y },
                  { x: bounds(selected).x + bounds(selected).w, y: bounds(selected).y },
                  { x: bounds(selected).x + bounds(selected).w, y: bounds(selected).y + bounds(selected).h },
                  { x: bounds(selected).x, y: bounds(selected).y + bounds(selected).h }]"
                [attr.x]="h.x - 4" [attr.y]="h.y - 4" width="8" height="8"
                fill="white" stroke="#3B82F6" stroke-width="1"></svg:rect>
    </svg:g>
  </svg:g>

  <!-- Annotation render template (svg: prefixes keep elements in the SVG namespace) -->
  <svg:g></svg:g>
</svg>

<ng-template #annTpl let-a>
  <svg:g [attr.opacity]="a.opacity == null ? 1 : a.opacity">
    <!-- pen / freehand -->
    <svg:polyline *ngIf="a.type === 'draw'" [attr.points]="penPoints(a)"
                  fill="none" [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth"
                  stroke-linecap="round" stroke-linejoin="round"></svg:polyline>

    <!-- arrow -->
    <svg:line *ngIf="a.type === 'arrow' && a.start && a.end"
              [attr.x1]="pxX(a.start.x)" [attr.y1]="pxY(a.start.y)"
              [attr.x2]="pxX(a.end.x)" [attr.y2]="pxY(a.end.y)"
              [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth"
              stroke-linecap="round" marker-end="url(#acv-arrow)"></svg:line>

    <!-- rectangle -->
    <svg:rect *ngIf="a.type === 'rectangle' && a.start && a.end"
              [attr.x]="rectX(a)" [attr.y]="rectY(a)" [attr.width]="rectW(a)" [attr.height]="rectH(a)"
              [attr.fill]="a.fillColor || 'none'" [attr.fill-opacity]="a.fillColor ? 0.4 : 0"
              [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth"></svg:rect>

    <!-- circle -->
    <svg:circle *ngIf="a.type === 'circle' && a.start && a.end"
                [attr.cx]="pxX(a.start.x)" [attr.cy]="pxY(a.start.y)" [attr.r]="radiusPx(a)"
                [attr.fill]="a.fillColor || 'none'" [attr.fill-opacity]="a.fillColor ? 0.4 : 0"
                [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth"></svg:circle>

    <!-- text -->
    <svg:text *ngIf="a.type === 'text' && a.start"
              [attr.x]="pxX(a.start.x)" [attr.y]="pxY(a.start.y)"
              [attr.fill]="a.color" [attr.font-size]="a.fontSize || 16" font-weight="bold"
              font-family="Inter, sans-serif">{{ a.text }}</svg:text>

    <!-- ruler / area -->
    <svg:g *ngIf="(a.type === 'ruler' || a.type === 'area') && a.start && a.end">
      <svg:line [attr.x1]="pxX(a.start.x)" [attr.y1]="pxY(a.start.y)"
                [attr.x2]="pxX(a.end.x)" [attr.y2]="pxY(a.end.y)"
                [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth"
                stroke-linecap="round"></svg:line>
      <!-- End-ticks (perpendicular) at both endpoints -->
      <svg:line [attr.x1]="rulerTick(a, 'start', 1).x" [attr.y1]="rulerTick(a, 'start', 1).y"
                [attr.x2]="rulerTick(a, 'start', -1).x" [attr.y2]="rulerTick(a, 'start', -1).y"
                [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth" stroke-linecap="round"></svg:line>
      <svg:line [attr.x1]="rulerTick(a, 'end', 1).x" [attr.y1]="rulerTick(a, 'end', 1).y"
                [attr.x2]="rulerTick(a, 'end', -1).x" [attr.y2]="rulerTick(a, 'end', -1).y"
                [attr.stroke]="a.color" [attr.stroke-width]="a.strokeWidth" stroke-linecap="round"></svg:line>
      <!-- Outlined measurement text (white fill, dark stroke) — matches MP strokeText/fillText -->
      <svg:text class="acv__measure" [attr.x]="midX(a) + 10" [attr.y]="midY(a) - 10"
                text-anchor="start">{{ measureLabel(a) }}</svg:text>
    </svg:g>
  </svg:g>
</ng-template>
